module.exports = __webpack_public_path__ + "static/media/bag-slash.b4fe64c5.svg";